import axios from 'axios';
import get from 'lodash/get';
import isArray from 'lodash/isArray';
import { trackIdentifyUser } from '../utils/tracker';
import { configuration } from '../configuration';

const API = {
  LIST_EMAIL: '/getEmailOTP',
  AUTH_OTP: '/authGEB',
  REQUEST_OTP: '/request-otp-geb',
  SUBMIT_CAPTCHA: '/check-captcha-request-otp-geb',
  SUBMIT_OTP: '/check-otp',
};

const axiosInstance = axios.create({
  baseURL: configuration.webServiceEndpoint[configuration.mode],
});

axiosInstance.interceptors.response.use(
  response => {
    return response.data;
  },
  error => {
    return Promise.reject(error);
  },
);

const parseResError = error => ({
  status: 'error',
  error,
});

export function logControl() {
  //   //category = user
  //   //action = action_page
  //   //label = description
  //   //value: number;  = success/failed
  //   //nonInteraction?: boolean;
  // return ReactGA.event({
  //   category: user,
  //   action: action,
  //   label: description,
  //   value: value
  // });
}

export const initSystemRef = (
  callback,
  system,
  id,
  fb_account_linking_token,
  line_account_linking_token,
  lineid,
) => ({
  type: 'INIT_SYSTEM_REF',
  callback,
  system,
  id,
  fb_account_linking_token,
  line_account_linking_token,
  lineid,
});
//export const setFBAuthorizationCode = (fb_authorization_code) => ({type: 'SET_AUTHORIZATION_CODE', fb_authorization_code})

export const setLanguage = language => ({ type: 'SETLANGUAGE', language });

//result.countCheckOtp, result.expirydate, result.email, result.ref, result.sec1)
export const setProfile = (count, expireDate, email, otpREF, OTP) => ({
  type: 'SETPROFILE',
  count,
  expireDate,
  email,
  otpREF,
  OTP,
});

export const setID = id => ({ type: 'SETID', id });

export const setName = name => ({ type: 'SETNAME', name });

export const setCaptchaStatus = captcha_status => ({
  type: 'SET_CAPTCHA_STATUS',
  captcha_status,
});

export const setEmail = email => ({ type: 'SETEMAIL', email });

export const setSession = session => ({ type: 'SETSESSION', session });

export const setCaptcha = (captcha, captcha_ref) => ({
  type: 'SET_CAPTCHA',
  captcha,
  captcha_ref,
});

export const setOTP = (OTP, otpREF) => ({ type: 'SET_OTP', OTP, otpREF });

export const getEmailsByUsername = username => async dispatch => {
  try {
    const response = await axiosInstance.post(API.LIST_EMAIL, {
      username,
    });
    let { data, status, messageCode, message } = response || {};
    const result = data || {};
    const lengthEmail = get(result, 'email.length');
    if (status === 'success' && lengthEmail > 0) {
      dispatch(setID(username));
      dispatch({
        type: 'SET_EMAILS',
        emails: isArray(result.email) ? result.email : [result.email],
      });
      trackIdentifyUser({ username });
    } else {
      status = 'error';
    }
    return {
      status,
      code: messageCode,
      message,
    };
  } catch (error) {
    return parseResError(error);
  }
};

//Async Action
/*
{"status":"success","messageCode":null,"data":{"ref":"KYXO","sec1":"439811","expirydate":1530872292120,"countCheckOtp":1,"username":"TEST001","rowStatus":null,"email":"banyat.XXXXim@prudential.co.th"}}
*/
export const checkID = (username, email) => async dispatch => {
  try {
    const response = await axiosInstance.post(API.AUTH_OTP, {
      username,
      email,
    });
    if (response.status === 'success') {
      let result = response.data;
      dispatch(setID(username));
      dispatch(
        setProfile(
          result.countCheckOtp,
          result.expirydate,
          email,
          result.ref,
          result.sec1,
        ),
      );
    }
    return {
      status: response.status,
      code: response.messageCode,
      message: response.message,
    };
  } catch (error) {
    return parseResError(error);
  }
};

//OTP
//result.countCheckOtp, result.expirydate, result.email, result.ref, result.sec1)
export const requestOTP = (username, email) => async dispatch => {
  try {
    const response = await await axiosInstance.post(API.REQUEST_OTP, {
      username,
      email,
    });
    if (response.status === 'success') {
      let responseData = response.data || {};

      dispatch(setCaptchaStatus('success'));
      dispatch(
        setProfile(
          responseData.count,
          responseData.expirydate,
          email,
          responseData.ref,
          responseData.sec1,
        ),
      );
    } else if (response.status === 'CaptchaRequest') {
      dispatch(setCaptchaStatus('CaptchaRequest'));
    }
    return {
      status: response.status,
      code: response.messageCode,
      message: response.message,
    };
  } catch (error) {
    return parseResError(error);
  }
};

//response.data = { status: "error", messageCode : '003' , message: "OTP is expired"}
export const checkOTP = (username, ref, OTP) => async (dispatch, getState) => {
  try {
    const { email } = getState().user;
    const response = await axiosInstance.post(API.SUBMIT_OTP, {
      username,
      ref: ref,
      sec1: OTP,
      email,
    });
    if (response) {
      if (response.status === 'error') {
        if (response.messageCode === 'OTP001') {
          dispatch(setOTP(response.data.sec1, response.data.data.ref));
        } else if (response.messageCode === 'CAPT003') {
          dispatch(setCaptchaStatus('CaptchaCheck'));
        }
        dispatch(setCaptchaStatus('error'));
      }
    }
    return { data: response };
  } catch (error) {
    return {
      data: parseResError(error),
    };
  }
};

export const genCaptcha = id => dispatch => {
  try {
    return axios
      .get(
        `${
          configuration.webServiceEndpoint[configuration.mode]
        }/gen-captcha?username=${id}`,
      )
      .then(response => {
        if (
          response.data.status === 'Refresh' ||
          response.data.status === 'success'
        ) {
          let captcha = response.data.data.url_captcha;
          let captcha_ref = response.data.data.ref_captcha;
          dispatch(setCaptcha(captcha, captcha_ref));
          return captcha_ref;
        } else {
          return response.message;
        }
      })
      .catch(function (error) {
        // //console.log(error);
        return error;
      });
  } catch (error) {
    return error;
  }
};

//Check OTP from Wrong Input OTP
export const checkCaptchaSendOTP =
  (username, inputCaptcha, ref_captcha, ref, sec1) => (dispatch, getState) => {
    try {
      const { email } = getState().user;
      return axios
        .post(
          `${
            configuration.webServiceEndpoint[configuration.mode]
          }/check-captcha-send-otp`,
          {
            username: `${username}`,
            inputCaptcha: `${inputCaptcha}`,
            ref_captcha: `${ref_captcha}`,
            ref: `${ref}`,
            sec1: `${sec1}`,
            email,
          },
        )
        .then(response => {
          // let result = response.data.data
          ////console.log(response)
          //let status = response.data.status

          // if (status === "success") {
          //   dispatch(setName(response.data.data.username))
          // }
          // else if(status === "error") {
          //   if(response.data.messageCode === 'CAPT001') {
          //     dispatch(setOTP(response.data.data.sec1,response.data.data.ref))
          //   }
          //   else if(response.data.messageCode === 'CAPT002') {
          //     dispatch(setOTP(response.data.data.sec1,response.data.data.ref))
          //   }
          //   else if(response.data.messageCode === 'CAPT003') {
          //     dispatch(setOTP(response.data.data.sec1,response.data.data.ref))
          //   }
          //}

          return {
            status: response.data.status,
            code: response.data.messageCode,
            message: response.data.message,
            data: response.data,
          };
        })
        .catch(function (error) {
          //console.log(error);
          return error;
        });
    } catch (error) {
      return error;
    }
  };

//Check Captcha from Multiple Request OTP
//result.countCheckOtp, result.expirydate, result.email, result.ref, result.sec1)
export const checkCaptchaRequestOTP =
  (username, inputCaptcha, ref_captcha, email) => dispatch => {
    try {
      return axiosInstance
        .post(API.SUBMIT_CAPTCHA, {
          username,
          inputCaptcha,
          ref_captcha,
          email,
        })
        .then(response => {
          // //console.log(response)
          if (response.status === 'success') {
            let responseData = response.data || {};
            //let count = 6

            dispatch(setCaptchaStatus('success'));
            dispatch(
              setProfile(
                responseData.count,
                responseData.expirydate,
                email,
                responseData.ref,
                responseData.sec1,
              ),
            );
          }

          return {
            status: response.status,
            code: response.messageCode,
            message: response.message,
          };
        })
        .catch(function (error) {
          //console.log(error);
          return error;
        });
    } catch (error) {
      return error;
    }
  };

export const addLog =
  (username, status, log_action, message_code, system_name) => () => {
    try {
      let item = {
        username: username,
        status: status,
        log_action: log_action,
        message_code: message_code,
        system_name: system_name,
      };

      return axios
        .post(
          `${configuration.webServiceEndpoint[configuration.mode]}/add-log`,
          item,
        )
        .then(response => {
          if (response.data.status === 'success') {
            return 'success';
          } else {
            return 'error';
          }
        })
        .catch(function (error) {
          //  //console.log(error);
          return error;
        });
    } catch (error) {
      return error;
    }
  };
